import RestClient from "./RestClient";

export const mainIp = "https://dreamlagoons.com.mx";

export default class API extends RestClient {
  constructor(authToken) {
    super("https://dreamlagoons.com.mx/api", {
      headers: {
        // Include as many custom headers as you need
        Authorization: authToken
      }
    });
    this.authToken = authToken;
    this.idOrganizationGod = "";
  }

  sendMail(email, body, subject) {
    const url = "/Organizations/sendEmail";
    return this.POST(url, { email, body, subject });
  }

  getContentOf(idPage) {
    const url = "/Organizations/getContentOf";
    return this.GETPASSVALUE(url, { idPage: idPage });
  }

  getData(nameOrg) {
    const url = "/Organizations/getData";
    return this.GETPASSVALUE(url, { nameOrg: nameOrg });
  }

  getDevelopments(nameOrg) {
    const url = "/Organizations/getDevelopmentsURLs";
    return this.GETPASSVALUE(url, { nameOrg: nameOrg });
  }

  getDevelopmentsProperties(nameOrg) {
    const url = "/Organizations/getDevelopmentPropertiesURLs";
    return this.GETPASSVALUE(url, { nameOrg: nameOrg });
  }

  getDevelopment(developmentId) {
    const url = "/Organizations/getDevelopment";
    return this.GETPASSVALUE(url, { developmentId: developmentId });
  }

  getDevelopmentSplashData(developmentId) {
    const url = "/Organizations/getDevelopmentSplashData";
    return this.GETPASSVALUE(url, { developmentId: developmentId });
  }

  getDevelopmentProperty(developmentPropertyId) {
    const url = "/Organizations/getDevelopmentProperty";
    return this.GETPASSVALUE(url, {
      developmentPropertyId: developmentPropertyId
    });
  }

  contactARA(data) {
    const url = "/Organizations/insertaContactoExterno";
    return this.POST(url, { data: data });
  }

  getInformacionLugaresNacimiento() {
    const url = "/Organizations/getInformacionLugaresNacimiento";
    return this.GET(url);
  }

  sendEmailWelcome(name, email, phone, modelId = '') {
    const url = "/Organizations/sendEmailWelcome";
    
    return this.POST(url, { name: name, email: email, phone: phone, modelId });
  }
}
